const ID_TOKEN_KEY = 'token_id';
const REFRESH_TOKEN = 'refresh_token';

export default {
  getToken () {
    return window.localStorage.getItem(ID_TOKEN_KEY);
  },

  getRefreshToken () {
    return window.localStorage.getItem(REFRESH_TOKEN);
  },

  saveToken (token) {
    window.localStorage.setItem(ID_TOKEN_KEY, token);
  },

  saveRefreshToken (refreshToken) {
    window.localStorage.setItem(REFRESH_TOKEN, refreshToken);
  },

  destroyToken () {
    window.localStorage.removeItem(ID_TOKEN_KEY);
    window.localStorage.removeItem(REFRESH_TOKEN);
  }
}
